import { config } from "../../config";
import axios from "axios";
import moment from "moment";

export class TasksService {

    public listTasksByBuildingId = async (buildingId: string, from = "1-1-1970", to = moment(new Date()).format("YYYY-MM-DD")): Promise<any> => {
      try {
        console.log(from, to)
        const { serverUrl } = config;
        const tasks = await axios.get(
          serverUrl + `statistics/reports/building/${buildingId}/employees/${from}/${to}`
        );
        return tasks.data;
      } catch (err) {
        return [];
      }
    }

    public listTasks = async (): Promise<any[]> => {
      try {
        const { serverUrl } = config;
        const tasksFilter = await axios.get(
          serverUrl + "statistics/task/all"
        );
        return tasksFilter.data;
      } catch (err) {
        return [];
      }
    };

    public listTaskRating = async (buildingId: string, employeeId: string, taskId: string): Promise<any> => {
      try {
        const { serverUrl } = config;
        const ratings = await axios.get(
          serverUrl + `statistics/reports/building/${buildingId}/employees`
        );
        return ratings.data;
      } catch (err) {
        return [];
      }
    }
        
}